
module App.Interfaces {
    export interface ISessionService {
        
        composition: Classes.IComposition;

        currentStep: string;

        maxStepNumber: number;

        setNumber: string;
        
        reset(): void;

        resetStoreSession(): void;

        resetMaxStepNumber(): void;
    }
}